import { standAlonePathName } from '../../../areas/area-pathnames';
import {
  authorityAreaPathName,
  citizenAreaPathName,
  citizenDetailsTabPathName,
  particularitiesPath,
  temporaryAddressPath,
} from '../../../areas/citizen/authority/citizen-authority-area-pathnames';
import { OmnibarEntry } from '../omnibar-interfaces';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';
import { addressHistorySection, personAndContactDetailsSection } from '../utils/use-omnibar-section';

function detailsSectionUrl(section: string) {
  return `/deeplink/citizen/:contextId/${citizenDetailsTabPathName}?omnibar-link=${section}`;
}

const functions: OmnibarEntry[] = [
  {
    id: '8e2c5a7f-1d4b-4f9e-a3c6-b7d0e9f2a481',
    label: 'Person- og kontaktoplysninger',
    keywords: ['personoplysninger', 'kontaktoplysninger', 'telefon', 'e-mail'],
    context: 'citizen',
    group: 'Borgerområde',
    url: detailsSectionUrl(personAndContactDetailsSection),
    hideForAnonymousCitizen: true,
    featureToggleRequired: catalogCorrectionsToggle,
  },
  {
    id: 'f4a9d1c6-7b3e-4a2d-9c58-e1b6f0d3a729',
    label: 'Adresser',
    keywords: ['adressehistorik', 'flytning', 'folkeregisteradresse'],
    context: 'citizen',
    group: 'Borgerområde',
    url: detailsSectionUrl(addressHistorySection),
    hideForAnonymousCitizen: true,
    featureToggleRequired: catalogCorrectionsToggle,
  },
  {
    id: '1c7e3b9a-5f2d-4e8b-b6a4-d9c2f7e0a513',
    label: 'Redigér særlige forhold',
    keywords: ['særlige forhold'],
    context: 'citizen',
    group: 'Borgerhandling',
    callbackFn: (contextId: string) => {
      window.open(`/${standAlonePathName}/${citizenAreaPathName}/${contextId}/${particularitiesPath}`);
    },
    hideForAnonymousCitizen: true,
    featureToggleRequired: catalogCorrectionsToggle,
  },
  {
    id: '9b5d2f8e-3a6c-4d1f-a7e9-c4b8d0f6e352',
    label: 'Redigér midlertidig adresse',
    keywords: ['adresse', 'c/o'],
    context: 'citizen',
    group: 'Borgerhandling',
    callbackFn: (contextId: string) => {
      window.open(`/${citizenAreaPathName}/${authorityAreaPathName}/${contextId}/${temporaryAddressPath}`);
    },
    hideForAnonymousCitizen: true,
    featureToggleRequired: catalogCorrectionsToggle,
  },
];

export default functions;
